import ReactDOM from "react-dom/client";
import { App } from "./App";
import 'core-js';
import 'regenerator-runtime/runtime';
import {  Suspense } from 'react';
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';


// Create a client
export const queryClient = new QueryClient();
ReactDOM.createRoot(document.getElementById("root")).render(
    <QueryClientProvider client={queryClient}>
      <Suspense fallback="loading...">
        <App />
      </Suspense>
    </QueryClientProvider>

);
